import { loadScript, removeScripts } from 'common-utils';

import { TrackingTool } from '../tracking-tool';

declare global {
  interface Window {
    // eslint-disable-next-line
    hj: any;
    // eslint-disable-next-line
    _hjSettings: any;
  }
}

export class Hotjar implements TrackingTool {
  private readonly _id: string;
  private readonly _sv: string;

  constructor(id: string, sv: string) {
    this._id = id;
    this._sv = sv;
  }

  async turnOff() {
    removeScripts([
      `https://static.hotjar.com/c/hotjar-${this._id}.js?sv=${this._sv}`,
    ]);
  }

  async turnOn() {
    if (typeof window !== 'undefined') {
      window.hj =
        window.hj ||
        function () {
          (window.hj.q = window.hj.q || []).push(arguments);
        };

      window._hjSettings = {
        id: this._id,
        hjsv: this._sv,
      };
      const src = `https://static.hotjar.com/c/hotjar-${this._id}.js?sv=${this._sv}`;
      await loadScript(src);
    }
  }

  getName(): string {
    return 'hotjar';
  }
}
